import { useTheme } from './theme-provider';
import { Mode } from '@/components/ui/Mode';
import { UpdateCurrentUser } from '@/services/data-services/Team';
import { useEffect } from 'react';

export function ModeToggle() {
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));

      if (userData?.user?.preferences?.theme) {
        setTheme(userData.user.preferences.theme);
      }
    } catch (error) {
      console.error('Error loading user theme preference:', error);
    }
  }, []);

  const toggleTheme = (checked) => {
    const newTheme = checked ? 'dark' : 'light';
    setTheme(newTheme);

    try {
      let userData = null;
      try {
        userData = JSON.parse(localStorage.getItem('user'));
      } catch (e) {
        console.error('Error parsing user data:', e);
      }

      let isAuthenticated = false;
      try {
        const persistAuth = localStorage.getItem('persist:auth');
        if (persistAuth) {
          const authData = JSON.parse(persistAuth);
          isAuthenticated =
            authData.isAuthenticated === '"true"' ||
            authData.isAuthenticated === 'true';
        }
      } catch (error) {
        console.error('Error parsing persist:auth:', error);
      }

      if (userData && userData.user) {
        if (isAuthenticated) {
          const preferences = { theme: newTheme };
          UpdateCurrentUser({ preferences })
            .then(() => {
              userData.user.preferences = {
                ...userData.user.preferences,
                theme: newTheme,
              };
              localStorage.setItem('user', JSON.stringify(userData));
            })
            .catch((error) => {
              console.error('Error updating user theme preference:', error);
            });
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  return (
    <Mode
      theme={theme}
      checked={theme === 'dark'}
      onCheckedChange={toggleTheme}
    />
  );
}
